export default __webpack_public_path__ + "static/uniswap-graphic-tilted-f78fe3703d4a5100c7ae6283645738d1.svg";